import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import * as UserActions from '../state/user/actions';
import * as BeverageActions from '../state/beverage/actions';

import * as BeerStyleActions from '../state/beer-style/actions';
import * as BarSettingsActions from '../state/bar-settings/actions';
import * as BarActions from '../state/bar/actions';
import * as StatisticActions from '../state/statistics/actions';
import * as UnitsActions from '../state/units/actions';
import * as LocationActions from '../state/location/actions';
import * as KegActions from '../state/keg/actions';
import * as Co2BottleActions from '../state/co2-bottle/actions';
import * as FermenterActions from '../state/fermenter/actions';
import * as TapActions from '../state/tap/actions';
import * as TowerActions from '../state/tower/actions';
import * as ExternalApiSettingsActions from '../state/external-api-settings/actions';
import * as PlaatoActions from '../state/plaato/actions';
import * as fromPlaato2 from '../state/plaato2';
import * as KegtronActions from '../state/kegtron/actions';
import * as CustomKegMonActions from '../state/custom_keg_mon/actions';
import * as SubscriptionActions from '../state/subscription/actions';
import * as FontActions from '../state/font/actions';
import * as OnTapAdvancedActions from '../state/on_tap_advanced/actions';

import * as fromOnTapTvActiveDisplay from '../state/on-tap-tv-active-displays';
import * as OnTapAdvancedCardTemplateActions from '../state/on_tap_advanced_card_template/actions';
import * as OnTapTemplateActions from '../state/ontap-template/actions';
import * as NotificationActions from '../state/notification/actions';
import * as StripeProductActions from '../state/stripeProduct/actions';
import * as StripeSubscriptionActions from '../state/stripeSubscription/actions';
import * as VoucherActions from '../state/voucher/actions';
import * as  BottleActions from '../state/bottle/actions';
import * as  CanActions from '../state/can/actions';

import { clearAllItems } from '../state/location/actions';
import { environment } from 'environments/environment';
import { Capacitor } from '@capacitor/core';
import * as fromStripeCustomer from 'app/state/stripeCustomer/actions';
import * as fromRevenuecatCustomer from 'app/state/revenuecat-customer/actions';
import * as SupportActions from '../state/support/actions';

@Injectable({
  providedIn: 'root'
})
export class DalHelper {

  constructor(
    private store: Store
  ) { }


  dispatchAllDals(barId: string, forceRefresh: boolean = false) {
    if (forceRefresh) {
      this.store.dispatch(TapActions.clearAllItems());
      this.store.dispatch(BeverageActions.clearAllItems());
      this.store.dispatch(LocationActions.clearAllItems());
      this.store.dispatch(BeverageActions.clearAllItems());
      this.store.dispatch(BeerStyleActions.clearAllItems());
      this.store.dispatch(KegActions.clearAllItems());
      this.store.dispatch(Co2BottleActions.clearAllItems());
      this.store.dispatch(FermenterActions.clearAllItems());
      this.store.dispatch(TapActions.clearAllItems());
      this.store.dispatch(PlaatoActions.clearAllItems());
      this.store.dispatch(fromPlaato2.clearAllItems());
      this.store.dispatch(KegtronActions.clearAllItems());
      this.store.dispatch(CustomKegMonActions.clearAllItems());
      this.store.dispatch(BarSettingsActions.clearAllItems());
      this.store.dispatch(BarActions.clearItem());
      this.store.dispatch(StatisticActions.clearStatisticsForHomepage());
      this.store.dispatch(FontActions.clearAllItems());
      this.store.dispatch(OnTapAdvancedCardTemplateActions.clearAllItems());
      this.store.dispatch(OnTapAdvancedActions.clearAllItems());
      this.store.dispatch(OnTapTemplateActions.clearAllItems());
      this.store.dispatch(NotificationActions.clearAllItems());
      this.store.dispatch(StripeProductActions.clearAllItems());
      this.store.dispatch(StripeSubscriptionActions.clearAllItems());
      this.store.dispatch(fromStripeCustomer.clearAllItems());
      //this.store.dispatch(VoucherActions.clearAllItems());
      this.store.dispatch(BottleActions.clearAllItems());
      this.store.dispatch(CanActions.clearAllItems());
      this.store.dispatch(fromOnTapTvActiveDisplay.clearAllItems());
    }
    this.store.dispatch(UserActions.loadSubscriptions({ barId }));
    this.store.dispatch(UserActions.loadUser());

    // this.store.dispatch(fromStripeCustomer.loadItemFromUser());
    // this.store.dispatch(fromRevenuecatCustomer.loadItemFromUser());



    this.store.dispatch(LocationActions.loadItems({ barId, forceRefresh }));
    this.store.dispatch(UnitsActions.loadUnits({ barId, forceRefresh }));
    this.store.dispatch(BarActions.loadBar({ barId, forceRefresh }));
    this.store.dispatch(BeverageActions.loadItems({ barId, forceRefresh }));

    this.store.dispatch(BottleActions.loadItems());
    this.store.dispatch(CanActions.loadItems());

    this.store.dispatch(BeerStyleActions.loadItems({ barId, forceRefresh }));
    this.store.dispatch(KegActions.loadItems({ barId, forceRefresh }));
    this.store.dispatch(Co2BottleActions.loadItems({ barId, forceRefresh }));
    this.store.dispatch(FermenterActions.loadItems({ barId, forceRefresh }));
    this.store.dispatch(TapActions.loadItems({ barId, forceRefresh }));
    this.store.dispatch(TowerActions.loadItems({ barId, forceRefresh }));
    this.store.dispatch(ExternalApiSettingsActions.loadItem({ barId }));
    this.store.dispatch(PlaatoActions.loadItems({ barId, forceRefresh }));
    this.store.dispatch(fromPlaato2.loadItems({ barId, forceRefresh }));
    this.store.dispatch(KegtronActions.loadItems({ barId, forceRefresh }));
    this.store.dispatch(CustomKegMonActions.loadItems({ barId, forceRefresh }));
    this.store.dispatch(BarSettingsActions.loadItem({ barId }));
    this.store.dispatch(BarSettingsActions.loadItems({ barId, forceRefresh }));
    this.store.dispatch(StatisticActions.loadStatisticsForHomepage({ barId: barId, limit: 2 }));
    this.store.dispatch(BarSettingsActions.setItem({ id: barId }));

    this.store.dispatch(SubscriptionActions.loadItem({ barId }));
    this.store.dispatch(StripeSubscriptionActions.loadItems());

    //this.store.dispatch(VoucherActions.loadItems({ barId, forceRefresh }));
    this.store.dispatch(FontActions.loadItems());
    this.store.dispatch(OnTapAdvancedCardTemplateActions.loadItems());

    this.store.dispatch(fromOnTapTvActiveDisplay.loadItems({ barId, forceRefresh }));


    this.store.dispatch(OnTapAdvancedActions.loadItems({ barId, forceRefresh }));
    this.store.dispatch(OnTapTemplateActions.loadItems({ barId, forceRefresh }));
    this.store.dispatch(NotificationActions.loadUnreadItems({ barId, limit: environment.notificationsCount, forceRefresh }));
    this.store.dispatch(NotificationActions.loadReadItems({ barId, limit: environment.notificationsCount, forceRefresh }));
    this.store.dispatch(NotificationActions.loadCountReadNotifications({ barId }));
    this.store.dispatch(NotificationActions.loadCountUnreadNotifications({ barId }));
    this.store.dispatch(NotificationActions.loadCountUnreadBeverageNotifications({ barId }));
    this.store.dispatch(NotificationActions.loadCountReadTapNotifications({ barId }));
    this.store.dispatch(NotificationActions.loadCountUnreadTapNotifications({ barId }));

    this.store.dispatch(fromRevenuecatCustomer.loadItemFromUser());

    this.store.dispatch(SupportActions.loadUserThreadsFromState({ take: 100 }));

    if (!Capacitor.isNativePlatform()) {
      this.store.dispatch(StripeProductActions.loadItems());
    }


  }
}

